import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-22da0a0e"), n = n(), _popScopeId(), n);
var _hoisted_1 = {
  class: "tw-p-0 tw-flex tw-w-full"
};
var _hoisted_2 = {
  key: 0,
  class: "tw-h-0 tw-ml-5 tw-mr-[175px] tw-overflow-hidden tw-border-t tw-border-solid tw-border-w-lavender tw-opacity-100"
};
var _hoisted_3 = {
  key: 1,
  id: "container-dropdown-menu",
  class: "tw-absolute tw-w-full tw-p-5px tw-bg-white tw-rounded-b tw-text-12 tw-border tw-border-w-cultured tw-border-solid tw-border-t-0"
};
var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = {
  class: "tw-font-semibold tw-text tw-text-w-primary"
};
var _hoisted_7 = {
  key: 2,
  id: "zonesDesktop",
  ref: "zones",
  class: "map-autocomplete tw-text tw-leading-4"
};
var _hoisted_8 = {
  key: 0,
  class: "tw-h-0 tw-ml-5 tw-mr-[175px] tw-overflow-hidden tw-border-t tw-border-solid tw-border-w-lavender tw-opacity-100"
};
var _hoisted_9 = {
  class: "tw-ml-20px"
};
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["data-place-id", "data-url", "title"];
var _hoisted_12 = {
  key: 1,
  class: "tw-py-[14px]"
};
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = ["data-place-id", "data-url", "title"];
var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = ["src"];
var _hoisted_17 = ["innerHTML"];
var _hoisted_18 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_autocomplete = _resolveComponent("base-autocomplete");
  var _component_base_input = _resolveComponent("base-input");
  var _component_search_icon = _resolveComponent("search-icon");
  var _component_pin_icon = _resolveComponent("pin-icon");
  var _component_draw_icon = _resolveComponent("draw-icon");
  var _component_checkbox_btn = _resolveComponent("checkbox-btn");
  var _component_base_accordion_item = _resolveComponent("base-accordion-item");
  var _component_radio_button = _resolveComponent("radio-button");
  var _component_static_spinner = _resolveComponent("static-spinner");
  var _component_base_button = _resolveComponent("base-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    id: "input-container",
    ref: "placeBoxContainer",
    class: _normalizeClass(["container-search-box tw-w-full tw-relative", _ctx.containerClasses])
  }, [_ctx.valuation || _ctx.selling ? (_openBlock(), _createBlock(_component_base_autocomplete, {
    key: 0,
    id: "".concat(_ctx.activeTab === _ctx.TABTYPE.VALUATE ? 'valuation' : 'selling', "-autocomplete"),
    ref: "placeAutocomplete",
    modelValue: _ctx.valuationAddress,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.valuationAddress = $event),
    "data-cy": "".concat(_ctx.activeTab === _ctx.TABTYPE.VALUATE ? 'valuation' : 'selling', "-autocomplete-input"),
    theme: "bordered",
    placeholder: _ctx.labels.enter_a_address,
    "on-input-change-cb": _ctx.onInputChangeCb,
    "on-option-selected-cb": _ctx.optionSelectedCb,
    "disable-cb": _ctx.disableCb,
    disabled: _ctx.valuationAddressLoading,
    "fieldset-classes": "!tw-border-0",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.handleClick())
  }, null, 8 /* PROPS */, ["id", "modelValue", "data-cy", "placeholder", "on-input-change-cb", "on-option-selected-cb", "disable-cb", "disabled"])) : _ctx.freesearch ? (_openBlock(), _createBlock(_component_base_input, {
    key: 1,
    id: "freesearch-input",
    modelValue: _ctx.freesearchValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.freesearchValue = $event),
    "input-class": "tw-mt-5px",
    placeholder: _ctx.labels.place,
    autocomplete: "none",
    onKeydownEnterPressed: _ctx.confirmPlace
  }, null, 8 /* PROPS */, ["modelValue", "placeholder", "onKeydownEnterPressed"])) : (_openBlock(), _createBlock(_component_base_autocomplete, {
    key: 2,
    id: "place-ac",
    ref: "placeAutocomplete",
    "data-cy": "place-ac",
    class: _normalizeClass([{
      'show-zones': _ctx.showZoneModal
    }, {
      'dropdown-menu-shown': _ctx.dropDownMenu
    }]),
    "input-classes": "!tw-pr-[100px] tw-truncate",
    "fieldset-classes": [{
      '!tw-border-b-0 !tw-rounded-b-none': _ctx.dropDownMenu || _ctx.showZoneModal
    }],
    "dropdown-classes": "tw-z-20",
    "on-input-change-cb": _ctx.getPlaceFn,
    theme: _ctx.listing ? 'all-bordered' : 'bordered',
    placeholder: _ctx.placeholder,
    "disable-cb": _ctx.disableCb,
    "manual-close": _ctx.dropDownMenu,
    "model-value": _ctx.autocompleteValue,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = e => _ctx.managePlace(e.payload)),
    onClick: _cache[4] || (_cache[4] = $event => _ctx.handleClick()),
    onChangedValue: _cache[5] || (_cache[5] = v => {
      _ctx.dropDownMenu = false;
    })
  }, {
    lefticon: _withCtx(() => [_createVNode(_component_search_icon, {
      class: "text-input-icon left sm",
      width: 16,
      height: 16
    })]),
    righticon: _withCtx(() => []),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "fieldset-classes", "on-input-change-cb", "theme", "placeholder", "disable-cb", "manual-close", "model-value"])), _ctx.showPlaceMapDropDown ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createCommentVNode(" DROPDOWN MENU: PLACE + MAP "), !_ctx.listing && _ctx.dropDownMenu ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("v-if", true), _ctx.dropDownMenu ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createCommentVNode(" DROPDOWN PLACE "), _ctx.isSearchReady ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "popup-search-text",
    "data-cy": "update-search-text-btn",
    class: "tw-rounded-[5px] tw-p-10px tw-cursor-pointer tw-mb-5px",
    onClick: _cache[6] || (_cache[6] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.fromDropDownToZoneModal && _ctx.fromDropDownToZoneModal(...arguments);
    }, ["stop"]))
  }, [_createVNode(_component_pin_icon, {
    class: "tw-mr-5px tw-inline-block",
    width: 20,
    height: 20
  }), !!_ctx.searchBean.polygonFromMap ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.labels.insertSearchCity), 1 /* TEXT */)) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.labels.editCity), 1 /* TEXT */))])) : _createCommentVNode("v-if", true), _createCommentVNode(" DROPDOWN MAP "), _createElementVNode("div", {
    id: "popup-search-map",
    "data-cy": "open-map-drawing-btn",
    class: "tw-flex tw-items-center tw-rounded-[5px] tw-p-10px tw-cursor-pointer",
    onClick: _cache[7] || (_cache[7] = $event => _ctx.openMapDraw())
  }, [_createVNode(_component_draw_icon, {
    class: "tw-mr-10px",
    width: 16,
    height: 16
  }), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.labels.drawOnMap), 1 /* TEXT */)])])) : _createCommentVNode("v-if", true), _createCommentVNode(" CONTAINER ZONELIST "), !_ctx.areZonesAndLocalitiesEmpty() && _ctx.showZoneModal ? (_openBlock(), _createElementBlock("div", _hoisted_7, [!_ctx.listing ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : _createCommentVNode("v-if", true), _createElementVNode("ul", {
    id: "zone-list-desktop",
    class: _normalizeClass(["tw-w-full tw-absolute tw-bg-white tw-no-scrollbar tw-overflow-auto tw-border tw-border-w-cultured tw-block tw-rounded-b", {
      'listing': _ctx.listing
    }]),
    style: {
      "max-height": "250px",
      "box-shadow": "0 3px 3px rgba(27, 27, 27, 0.1)",
      "z-index": "1006"
    },
    tabindex: "0",
    onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("li", _hoisted_9, [_createVNode(_component_checkbox_btn, {
    id: "wholeMunicipality",
    class: "tw-flex tw-items-center",
    "input-class": "tw-shrink-0",
    "data-cy": "wholeMunicipality",
    label: _ctx.labels.wholeMunicipality,
    checked: !_ctx.isZoneOrLocalitySelected() && !(Object.keys(_ctx.districtSelected).length > 0),
    onChange: _cache[8] || (_cache[8] = $event => {
      _ctx.resetSearchBeanZonesAndLocalities();
      _ctx.showZoneModal = false;
      _ctx.confirmPlace();
    })
  }, null, 8 /* PROPS */, ["label", "checked"])]), _ctx.areZonesAndLocalitiesFilled() ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    class: "select-group tw-capitalize tw-font-semibold tw-ml-3 tw-mt-10px tw-mb-5px",
    innerHTML: _ctx.zonesLabel
  }, null, 8 /* PROPS */, _hoisted_10)) : _createCommentVNode("v-if", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneList, zone => {
    return _openBlock(), _createElementBlock("li", {
      key: zone.zoneID,
      class: "tw-mx-20px",
      "data-place-id": zone.placeID,
      "data-url": zone.zoneURL,
      title: zone.zoneName
    }, [zone.subPlaces.length > 0 ? (_openBlock(), _createBlock(_component_base_accordion_item, {
      key: 0,
      id: 'accordionWrapper_' + zone.zoneID,
      "arrow-width": 18,
      "btn-classes": "tw-p-2",
      "accordion-open-classes": "tw-py-10px",
      "root-classes": "tw-py-1"
    }, {
      custom_content: _withCtx(() => [_createVNode(_component_checkbox_btn, {
        id: 'checkbox_' + zone.zoneID,
        "data-id": 'checkbox_' + zone.zoneID,
        class: "tw-w-full",
        label: zone.zoneName,
        "container-id": 'accordionWrapper_' + zone.zoneID,
        checked: _ctx.isZoneSelected(zone.zoneID),
        onChange: $event => {
          _ctx.onPlaceLIClick(zone, _ctx.updatePlaceNameAndEmit);
        }
      }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"])]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zone.subPlaces, district => {
        return _openBlock(), _createBlock(_component_checkbox_btn, {
          id: district.districtID,
          key: district.districtID,
          "container-class": "tw-py-[4px]",
          "data-cy": "district_".concat(district.districtID),
          label: district.districtName,
          checked: _ctx.isDistrictSelected(district.zoneID, district.districtID) || _ctx.areAllDistrictsSelected(zone.zoneID),
          onChange: $event => {
            _ctx.onDistrictClick(zone, district, _ctx.updatePlaceNameAndEmit);
          }
        }, null, 8 /* PROPS */, ["id", "data-cy", "label", "checked", "onChange"]);
      }), 128 /* KEYED_FRAGMENT */))]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_checkbox_btn, {
      id: 'checkbox_' + zone.zoneID,
      "data-id": 'checkbox_' + zone.zoneID,
      "wrapper-margin-y": "tw-my-0",
      label: zone.zoneName,
      class: "tw-flex tw-items-center",
      "input-class": "tw-shrink-0",
      "container-id": 'accordionWrapper_' + zone.zoneID,
      "label-class": "tw-w-full",
      checked: _ctx.isZoneSelected(zone.zoneID),
      onChange: $event => {
        _ctx.onPlaceLIClick(zone, _ctx.updatePlaceNameAndEmit);
      }
    }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"])]))], 8 /* PROPS */, _hoisted_11);
  }), 128 /* KEYED_FRAGMENT */)), _ctx.localityList.length ? (_openBlock(), _createElementBlock("li", {
    key: 1,
    class: "tw-capitalize tw-font-semibold tw-ml-3 tw-mt-10px tw-mb-5px",
    innerHTML: _ctx.localitiesLabel
  }, null, 8 /* PROPS */, _hoisted_13)) : _createCommentVNode("v-if", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localityList, locality => {
    return _openBlock(), _createElementBlock("li", {
      key: locality.localityID,
      "data-element": "",
      "data-place-id": locality.placeID,
      "data-url": locality.zoneURL,
      title: locality.localityName
    }, [_createVNode(_component_radio_button, {
      class: "tw-mx-20px tw-py-10px tw-flex tw-items-center",
      "label-classes": "tw-pl-10px",
      label: locality.localityName,
      "is-checked": _ctx.isLocationSelected(locality.localityID),
      onChange: $event => _ctx.onPlaceLIClick(locality, _ctx.updatePlaceNameAndEmit, true)
    }, null, 8 /* PROPS */, ["label", "is-checked", "onChange"])], 8 /* PROPS */, _hoisted_14);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)], 512 /* NEED_PATCH */)) : _createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */)) : _createCommentVNode("v-if", true), _createCommentVNode(" FREESEARCH DESKTOP "), _ctx.freesearch ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [_createVNode(_component_base_button, {
    id: "freesearch-btn",
    "is-loading": _ctx.spinnerIcon,
    class: _normalizeClass(['tw-hidden sm:tw-block tw-z-10 tw-absolute tw-text-w-primary tw-top-0 tw-end-0  !tw-mt-5px', {
      'tw-p-0 !tw-min-w-0': _ctx.spinnerIcon
    }]),
    "btn-class": "tw-btn-transparent",
    onClick: _ctx.confirmPlace
  }, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.labels.genericSearch
    }, null, 8 /* PROPS */, _hoisted_15)]),
    spinner: _withCtx(() => [_ctx.spinnerIcon ? (_openBlock(), _createBlock(_component_static_spinner, {
      key: 0,
      class: "tw-mr-10px tw-border-none tw-rounded tw-bg-w-secondary icon-xxl"
    })) : _createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-loading", "class", "onClick"]), _createCommentVNode(" FREESEARCH MOBILE "), _createVNode(_component_base_button, {
    class: _normalizeClass(['tw-mt-5px tw-flex sm:tw-hidden tw-absolute tw-top-0 tw-right-0 tw-items-center tw-justify-center', {
      'tw-p-0 tw-bg-transparent': _ctx.spinnerIcon
    }]),
    "btn-class": "tw-btn-w-primary",
    "is-loading": _ctx.spinnerIcon,
    onClick: _ctx.confirmPlace
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      class: "icon",
      width: "20",
      height: "20",
      src: "".concat(_ctx.cdn, "/_ui/img/Ico/search-white.svg"),
      alt: "icona Pin"
    }, null, 8 /* PROPS */, _hoisted_16)]),
    spinner: _withCtx(() => [_ctx.spinnerIcon ? (_openBlock(), _createBlock(_component_static_spinner, {
      key: 0,
      class: "tw-mr-10px tw-border-none tw-rounded tw-bg-w-secondary icon-xxl"
    })) : _createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "is-loading", "onClick"])], 64 /* STABLE_FRAGMENT */)) : _ctx.listing && !_ctx.dropDownMenu && !_ctx.showZoneModal && !_ctx.spinnerIcon && !_ctx.valuation && _ctx.placeTest ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 5
  }, [_createCommentVNode(" BUTTON MODIFY "), _createVNode(_component_base_button, {
    "btn-class": "btn-transparent tw-absolute tw-text-w-primary tw-top-0 tw-end-0",
    onClick: _cache[10] || (_cache[10] = e => _ctx.openDropDown(e))
  }, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.labels.genericEdit
    }, null, 8 /* PROPS */, _hoisted_17)]),
    _: 1 /* STABLE */
  })], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)) : _ctx.listing ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 6
  }, [_createCommentVNode(" BUTTON SEARCH  "), _createVNode(_component_base_button, {
    "data-cy": "placebox-search-btn",
    class: _normalizeClass(['tw-z-10 tw-absolute tw-text-w-primary tw-top-0 tw-end-0 disabled:tw-bg-transparent', {
      'tw-p-0': _ctx.spinnerIcon
    }]),
    "btn-class": "tw-btn-transparent",
    "is-loading": _ctx.spinnerIcon,
    onClick: _ctx.confirmPlace
  }, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.labels.genericSearch
    }, null, 8 /* PROPS */, _hoisted_18)]),
    spinner: _withCtx(() => [_ctx.spinnerIcon ? (_openBlock(), _createBlock(_component_static_spinner, {
      key: 0,
      class: "tw-mr-10px tw-border-none tw-rounded tw-bg-w-secondary icon-xxl"
    })) : _createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "is-loading", "onClick"])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)) : _createCommentVNode("v-if", true)], 2 /* CLASS */)]);
}